import React from 'react';
import{
    NoShipText,
    SetLocatedText,
    SetLocatedRowDiv,
    BatchText,
    RedCircle,
    Parked
    } from '../SetsAndItems.styled';
import {
    FooterContainer,
    FooterLabel,
    MultipleAllocations,
    RedCircleFlex,
    StyledDiv,
} from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard.styled.jsx';
import { getDisplayDate, getBrowserTimeZoneName } from 'src/utils/dateUtils';
import { 
    convertTime24To12, 
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { RED_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';

const ShippingDetails = (props) => {
    const {
        isScheduleSurgery,
        shipDontShipSurgery,
        batchCurrentLocation,
        batchId,
        isEquity,
        isConsignmentAdd,
        shippingRequirement,
        avoidDeploymentType,
        countryISOCode,
        batchParked,
        isEquityOrder,
        batchAlreadyAllocated
    }=props;
    const { t } = useTranslation();

    return (
        <>
            {isScheduleSurgery &&
            shipDontShipSurgery === 'NOT_VISIBLE' ? null : (
                <NoShipText
                    margin={
                        batchCurrentLocation && batchId
                            ? false
                            : '0px 0px 5px 0px'
                    }
                >
                    {isEquity ? t('equity.common.setsAndItems.noShip') 
                    : isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.requestedNoShip') 
                    : t('templates.common.addItemBundlePop.bundleItems.requestedNoShip')}
                </NoShipText>
            )}
            {shippingRequirement &&
            batchCurrentLocation &&
            batchId &&
            (avoidDeploymentType(countryISOCode)
                ? true
                : batchParked) ? ( // this condition s not there for equity
                <>
                    <SetLocatedText>
                        {isEquity ? t('equity.common.setsAndItems.setLocation') 
                        : isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.setLocationat')
                        : t('templates.common.addItemBundlePop.setsAndItems.setLocation')}
                    </SetLocatedText>
                    <SetLocatedRowDiv alignItem="center">
                        <BatchText
                            width={batchParked ? '80%' : '100%'}
                        >
                            {batchCurrentLocation
                                ? `${t(
                                        'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                    )} ${batchId}: ${batchCurrentLocation}`
                                : 
                                !isEquityOrder ?  // not there for equity
                                `${t(
                                        'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                    )} ${batchId}` : ''}
                        </BatchText>
                        {batchParked ? (
                            <Parked>
                                {isEquity ? t('equity.common.setsAndItems.parked') 
                                : isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.parked') 
                                : t('templates.common.addItemBundlePop.setsAndItems.parked')}
                            </Parked>
                        ) : null}
                    </SetLocatedRowDiv>
                    {batchAlreadyAllocated ? (
                        <>
                            <FooterContainer
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                }}
                            >
                                <RedCircleFlex margin={'0px'}>
                                    <RedCircle
                                        style={{
                                            marginTop: '3.5px',
                                        }}
                                    >
                                        !
                                    </RedCircle>
                                    <FooterLabel color={RED_FONT_COLOR}>
                                            {isEquity ? t('equity.common.setsAndItems.allocated') 
                                            : isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.allocated') 
                                            : t('templates.common.addItemBundlePop.setsAndItems.allocated')}
                                    </FooterLabel>
                                </RedCircleFlex>
                                <StyledDiv>
                                    {batchAlreadyAllocated?.map(
                                        (data, index) => {
                                            return (
                                                <React.Fragment
                                                    key={index}
                                                >
                                                    <MultipleAllocations
                                                        width={
                                                            '281px'
                                                        }
                                                    >
                                                        <FooterLabel>
                                                            {getDisplayDate(
                                                                data.surgeryDate, t('dateFormat')
                                                            )}
                                                        </FooterLabel>
                                                        <FooterLabel>
                                                            {convertTime24To12(
                                                                new Date(
                                                                    data.surgeryDate
                                                                )
                                                            )}{' '}
                                                            (
                                                            {getBrowserTimeZoneName()}
                                                            )
                                                        </FooterLabel>
                                                        <FooterLabel>
                                                            |
                                                        </FooterLabel>

                                                        <FooterLabel className="common-account-dt-mask">
                                                            {
                                                                data.accountName
                                                            }
                                                        </FooterLabel>
                                                    </MultipleAllocations>
                                                </React.Fragment>
                                            );
                                        }
                                    )}
                                </StyledDiv>
                            </FooterContainer>
                        </>
                    ) : null}
                </>
            ) : null}
        </>
    );
};

export default ShippingDetails;